import { graphql } from "react-relay";

export const UpsertGCPIntegrationMutation = graphql`
  mutation UpsertGCPIntegrationMutation(
    $input: UpsertGCPIntegrationInput!
    $connections: [ID!]!
  ) {
    upsertGCPIntegration(input: $input) {
      gcpIntegration
        @appendNode(
          connections: $connections
          edgeTypeName: "GCPIntegrationEdge"
        ) {
        key
        customerConfig {
          organizations {
            orgId
            folderIds
            projectIds
          }
          securityContexts {
            name
            extraRoles
          }
          costSources {
            billingTable
          }
          infrastructure {
            projectId
            resourceLocation
            resourcePrefix
            createProject {
              billingAccountId
              orgId
              folderId
              labels {
                key
                value
              }
            }
          }
          terraformModule {
            blockHCL
            roundtripDigest
          }
        }
        accessConfig {
          infrastructure {
            projectId
          }
          organizations {
            id
            name
            folders {
              id
            }
            projects {
              id
            }
          }
          costSources {
            billingTable
          }
          securityContexts {
            name
            extraRoles
          }
          roundtripDigest
        }
      }
      problems {
        ... on Problem {
          message
        }
      }
    }
  }
`;
